import { FORM_ERROR_MSG } from '../../../../types/types';
import useAuth from '../../../../hooks/auth-hooks';
import { CARD_GROUP_FORM } from '../form-cardgroup-types';
import { showToast } from '../../../toasts';
import { checkForSelectValue } from '../../form-helpers';

import AwsPostNewCardGroup from '../../../../routes/post-new-card-group';

/**
 * Gets new card group form data and sends it to the API function
 * 
 * @returns void
 */
export const postNewCardGroup = () => {
  const { cgForm, cgPaymentMethod, cgHose, cgSubmitButton,cgName,cgMarginCents, cgTimeoutOverride, cgTerminaltax } = CARD_GROUP_FORM;

  const validateForm = (customerID: HTMLElement) => {
    cgForm.classList.add('was-validated');

    checkForSelectValue(cgPaymentMethod, 'Payment Type', 'payment');
    checkForSelectValue(cgHose, 'Hose Type', 'hose');

    customerID === null ? FORM_ERROR_MSG.innerHTML = 'Please select a customer' : FORM_ERROR_MSG.innerHTML = '';

    return cgForm.checkValidity() &&
        cgPaymentMethod.getAttribute('data-value') != null &&
        cgHose.getAttribute('data-value') != null &&
        customerID != null;
  };

  const postAndRedirect = async (awsData: any) => {
    const { body } = await AwsPostNewCardGroup(awsData);

    if ( body ) {
      showToast('aafp_toast', `${cgName.value} group has been added`);
      setTimeout(() => {
        location.href = '/card-group/';
      }, 1500);
    }
  };

  cgForm.addEventListener('submit', event => {
    event.preventDefault();
    event.stopPropagation();

    const customerID = document.querySelector('[data-customer]') as HTMLElement;

    if( validateForm(customerID) ) {        
      event.preventDefault();
      cgForm.classList.remove('was-validated');
      cgForm.classList.remove('form-control:valid');
      cgSubmitButton.classList.add('aafp_button-loading');
      FORM_ERROR_MSG.innerHTML = '';      

      const { userId } = useAuth()!;

      const awsJsonData = {
        wpId: userId,
        customerId: Number(customerID.getAttribute('data-customer')),
        cardGroupName: cgName.value,
        paymentMethod: Number(cgPaymentMethod.getAttribute('data-value')),
        marginCents: cgMarginCents.valueAsNumber,
        hoseType: String(cgHose.getAttribute('data-value')),
        timeoutOverride: cgTimeoutOverride.checked === true ? '1' : '0',
        terminalTax: cgTerminaltax.checked === true ? '1' : '0'
      }; 

      postAndRedirect(awsJsonData);
    }
  }); 
}